<template>
  <div class="max-w-2xl mx-auto my-10 p-6 bg-white shadow-md rounded-lg">
    <h1 class="text-2xl font-bold mb-4 text-center">
      2023 Year-End Financial Review
    </h1>
    <div class="flex justify-between mb-2">
      <span class="font-semibold">Beginning Balance (12/31/2022):</span>
      <span>$ 9,509.68</span>
    </div>
    <div class="flex justify-between mb-2">
      <span class="font-semibold">Fees Collected:</span>
      <span>$ 8,217.43</span>
    </div>
    <div class="flex justify-between mb-2">
      <span class="font-semibold">Landscaping:</span>
      <span>($ 2,064.35)</span>
    </div>
    <div class="flex justify-between mb-2">
      <span class="font-semibold">Printing:</span>
      <span>($ 423.46)</span>
    </div>
    <div class="flex justify-between mb-2">
      <span class="font-semibold">Infinity Solutions:</span>
      <span>($ 263.40)</span>
    </div>
    <div class="flex justify-between mb-2">
      <span class="font-semibold">Bank Fees:</span>
      <span>($ 17.50)</span>
    </div>
    <div class="flex justify-between mb-2">
      <span class="font-semibold">Insurance:</span>
      <span>($ 503.50)</span>
    </div>
    <div class="flex justify-between mt-4 pt-4 border-t border-gray-200">
      <span class="font-bold">Ending Balance (12/31/2023):</span>
      <span class="font-bold">$ 14,454.90</span>
    </div>
  </div>
</template>

<script setup></script>

<style>
/* Add any additional styles here if needed */
</style>
